import { Loader2 } from "lucide-react";

import { Card } from "../../components/ui/card";
import { Skeleton } from "../../components/ui/skeleton";

/** Grey rows shaped like the results table while eBay and the web are searched. */
export function ResultsSkeleton() {
  return (
    <Card className="flex flex-col gap-4" aria-busy="true">
      <div className="flex items-center gap-2 text-sm text-muted-foreground" role="status">
        <Loader2 className="size-4 animate-spin" aria-hidden="true" />
        Searching eBay and the web… this can take a few seconds.
      </div>
      <div className="flex gap-2" aria-hidden="true">
        <Skeleton className="h-6 w-28 rounded-full" />
        <Skeleton className="h-6 w-32 rounded-full" />
      </div>
      <div className="flex flex-col divide-y" aria-hidden="true">
        {Array.from({ length: 5 }, (_, i) => (
          <div key={i} className="flex items-center gap-4 py-3">
            <Skeleton className="size-14 shrink-0" />
            <div className="flex flex-1 flex-col gap-2">
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-1/3" />
            </div>
            <Skeleton className="hidden h-4 w-16 sm:block" />
            <Skeleton className="hidden h-6 w-20 rounded-full md:block" />
            <Skeleton className="h-8 w-28" />
          </div>
        ))}
      </div>
    </Card>
  );
}
